import { useEffect, useState } from 'react';
import { Board, Council } from 'types';
import { boardVisibilityTypes } from 'modules/boards/constants/boardVisibilityTypes';
import { basicBoardStatus } from 'modules/boards/constants/basicBoardStatus';
import { boardEntityTypes } from '../../BoardsListHeader/constants/boardEntityTypes';

type UseGetVisibilityProps = {
  board: Board | Council;
};

export const getVisibilityData = (board: Board | Council) => {
  let visibilityType;

  if (
    [boardEntityTypes.BOARD, boardEntityTypes.BASIC_BOARD].includes(
      (board as Board)?.entityType
    )
  ) {
    visibilityType = (board as Board)?.isVisible
      ? boardVisibilityTypes.VISIBLE
      : boardVisibilityTypes.NOT_VISIBLE;
  } else {
    visibilityType =
      (board as Council)?.status === basicBoardStatus.PENDING.value
        ? boardVisibilityTypes.NOT_VISIBLE
        : boardVisibilityTypes.VISIBLE;
  }

  const visibilityLabel = visibilityType.label;
  const visibilityBadge = visibilityType.badge;

  return { visibilityLabel, visibilityBadge };
};

export const useGetVisibility = ({ board }: UseGetVisibilityProps) => {
  const [visibilityLabel, setVisibilityLabel] = useState<string>('');
  const [visibilityBadge, setVisibilityBadge] = useState<string>('');

  useEffect(() => {
    const { visibilityLabel, visibilityBadge } = getVisibilityData(board);

    setVisibilityLabel(visibilityLabel);
    setVisibilityBadge(visibilityBadge);
  }, [board]);

  return {
    data: { visibilityLabel, visibilityBadge },
  };
};
